import React from 'react'
import { Link } from 'react-router-dom'
import { Heading, Text, Container, Card, CardBody, SimpleGrid, Box, CardHeader, Spinner } from '@chakra-ui/react'
import Styles from './landingpage.module.css'
import Header from './Header/Header'
import Connectors from './Connectors/Connectors'
import { useGetTrialConnectorsQuery } from '../../../features/marketplace/marketplaceApi'
import { paths } from '../../../app/routes'

/** The public page: trial connectors anyone can sign up for. */
const LandingPage = () => {
    const { data, isLoading, isError } = useGetTrialConnectorsQuery()
    const connectors = Array.isArray(data) ? data : []

    return (
        <>
            <Header />
            {isLoading ? (
                <Box className={Styles.parentBoxofLoader}>
                    <Box w="100%" height="100%" position="relative">
                        <Spinner
                            thickness="4px"
                            speed="0.65s"
                            emptyColor="gray.200"
                            color="blue.500"
                            size="xl"
                            position="relative"
                            top="50%"
                            transform="translateY(-50%)"
                            left="50%"
                        />
                    </Box>
                </Box>
            ) : null}
            <Container m="20px 0 0 0" maxWidth="100%" h="400px">
                <Card>
                    <CardHeader>
                        <Heading textAlign="center">
                            <Text as="span" color="#1935c1"> Available </Text>
                            <Text as="span" color="#dc332e"> Trial Connectors </Text>
                        </Heading>
                    </CardHeader>
                    <CardBody>
                        {isError ? <p>Error: the trial connectors could not be loaded.</p> : null}
                        <SimpleGrid columns={[2, 3, 4]} spacing="40px">
                            {connectors.map((item, index) => (
                                <Link
                                    key={item.id}
                                    to={{
                                        pathname: paths.trialConnector(item.id, item.name),
                                        state: {
                                            imageContent: item.imageContent,
                                            index,
                                            name: item.name,
                                            image: item.imageContent,
                                            sourceShortName: item.source ? item.source.shortName : undefined,
                                            targetShortName: item.target ? item.target.shortName : undefined
                                        }
                                    }}
                                >
                                    <Box position="relative" overflow="hidden" transition="transform 0.2s ease" _hover={{ transform: 'scale(1.05)' }}>
                                        <Connectors
                                            index={index}
                                            name={item.name}
                                            image={item.imageContent}
                                            sourceShortName={item.source ? item.source.shortName : undefined}
                                            targetShortName={item.target ? item.target.shortName : undefined}
                                        />
                                    </Box>
                                </Link>
                            ))}
                        </SimpleGrid>
                    </CardBody>
                </Card>
            </Container>
        </>
    )
}

export default LandingPage
